import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ManualEntry() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.get(`/tools/by-code/${encodeURIComponent(code.trim())}`);
      navigate(`/worker/timer/${encodeURIComponent(data.code)}`);
    } catch (err) {
      console.error("Tool lookup failed:", err);
      toast.error(`Tool code "${code}" not found`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5" data-testid="manual-entry-page">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
          Manual code
        </p>
        <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mt-1">
          Enter tool code
        </h1>
        <p className="text-slate-600 text-sm mt-1">
          Type the code printed on the tool's QR label.
        </p>
      </div>

      <Card className="p-5 border-slate-200">
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">
              Tool code
            </Label>
            <Input
              autoFocus
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              className="h-14 mt-2 text-2xl font-mono tracking-widest text-center border-2 border-slate-300 rounded-xl"
              placeholder="e.g. BR-001"
              data-testid="manual-code-input"
            />
          </div>
          <Button
            type="submit"
            disabled={busy || !code.trim()}
            className="w-full touch-btn h-16 bg-slate-900 hover:bg-slate-800 text-white text-lg font-bold rounded-xl"
            data-testid="manual-submit-btn"
          >
            {busy ? "Loading…" : "Start timer"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
